<li id="account-settings-cell" class="nav-item" [class.is-active]="isActive">
  <div class="circle-avatar-wrapper">
    <div class="circle-avatar-white-border-wrapper">
      <msd-avatar [src]="avatarUrl" [text]="initials"></msd-avatar>
    </div>
  </div>
  <h6 class="desktop">Paramètres du compte</h6>
  <h6 class="mobile">{{label}}</h6>
</li>
